// Labels shared by PDF export views (company drawer + past-assessment v1/v2/v3).
export const EXPORT_CONTENT_LABELS = {
  headings: {
    inherentRisk: 'INHERENT RISK',
    description: 'DESCRIPTION',
    businessOwner: 'BUSINESS OWNER',
    controlCategory: 'CONTROL CATEGORY',
  },
  sections: {
    thirdPartyArtifacts: 'Third-Party Artifacts',
    thirdPartyControlsAndAlerts: 'Third Party Controls & Alerts',
  },
  alertDetails: {
    description: 'Description',
    mitigation: 'Mitigation',
  },
  controlSingular: 'Control',
} as const
